/*global angular*/
'use strict';

angular.module('MrDWebApp').controller('OrderCtrl', function ($scope, $location, $rootScope, $state) {

  //var _oc = this;

  //$previousState.memo('caller');

  $scope._rc.bodyClass = 'html-order';

  if (window.env.domainSplit) window.location.href = '/'; else $state.go('home');
  
  $scope._rc.initAutocomplete();
  
});
